export default __webpack_public_path__ + "static/media/logo_name.f1de4571.png";